/* @Note Kindly use this file to define all the 
type guards and utility functions that can be used across the project */

export function isDefined<T>(arg: T | undefined): arg is T {
  return typeof arg !== 'undefined';
}

export function nonNullable<T>(arg: T | undefined | null): arg is T {
  return typeof arg !== 'undefined' && arg !== null;
}

export function isDate<T>(arg: T | undefined | null): arg is T {
  return nonNullable(arg) && arg instanceof Date;
}

export function isString<T>(arg: T): arg is T {
  return nonNullable(arg) && typeof arg === 'string';
}

export function isHTMLElement<T>(arg: T): arg is T {
  return nonNullable(arg) && arg instanceof HTMLElement;
}
export type WithOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

//@Note Define the generic action creator function that accepts any string literal as the type
export function createAction<T extends string, P>(type: T, payload?: P) {
  return {
    type,
    payload,
  };
}

export const PROMISE_SUFFIX_FOR_SUCCESSS = '_FULFILLED';
export const PROMISE_SUFFIX_FOR_PENDING = '_PENDING';
export const PROMISE_SUFFIX_FOR_REJECTED = '_REJECTED';

export enum Paymodes {
  PAH_WITHOUT_CC = 'PAH_WITHOUT_CC',
  PAH_WITH_CC = 'PAH_WITH_CC',
  PAH_GOCASH = 'PAH_GOCASH',
  BNPL = 'BNPL',
  PAS = 'PAS',
}

export interface DataPatcher<T> {
  data: T;
}

export interface CGResponse<T> {
  data: {
    response: T;
  };
  correlationKey: string;
}
